import React from 'react';
import { DefaultTools } from './DefaultTools';
import { CATEGORIES_TOOLS } from './constants';
import { VibrationTools } from './VibrationTools';
import type { RelatedReport } from '@/context/Resolution886Report/types';

interface ErgonomicToolsProps {
	category: string;
	relatedReport: RelatedReport | null;
}

const JDS_D86_TOOL_KEY = 'jds_d86';

export function ErgonomicTools({ category, relatedReport }: Readonly<ErgonomicToolsProps>): JSX.Element {
	const categoryTool = CATEGORIES_TOOLS.find((tool) => tool.category_key === category);

	if (!categoryTool?.tool) {
		return <></>;
	}

	if (categoryTool?.tool === JDS_D86_TOOL_KEY) {
		return (
			<VibrationTools
				name={categoryTool?.name as string}
				categoryKey={categoryTool?.category_key as string}
				relatedReport={relatedReport}
			/>
		);
	}

	return (
		<DefaultTools
			tool={categoryTool?.tool}
			relatedReport={relatedReport}
			name={categoryTool?.name as string}
			category_key={categoryTool?.category_key as string}
			category_name={categoryTool?.category_name as string}
		/>
	);
}
